define(['underscore', 'edge/platform/base/BaseCtrl'], (_, BaseCtrl)=> {
    const fn = (LocaleService, $filter, $scope, $anchorScroll, StateUtils, LoadSaveService, MVRClueService, $window, submissionViewModel, $state, ModalService, InMemorySession, ErrorHandlingService, $timeout)=> {
    const ctrl = Object.create(BaseCtrl);
    const flowModel = StateUtils.activeDataForState(true).flowModel;
    const submissionVM = submissionViewModel();
    var vehicles;
    var drivers;
    var mvrClueFlag;
    var doReQuoteOnFail;



ctrl.init = ()=> {
    const quoting = submissionVM.quoteData.value;
    $anchorScroll();
    $scope.page = {
        sessionUUID: submissionVM.sessionUUID.value,
        quoteID: submissionVM.quoteID.value,
        productCode : submissionVM.value.draftData.productCode
    };
    if(submissionVM.value.draftData.productCode === "Homeowners") {
        $scope.page.standardQuotes = _.where(quoting.offeredQuotes, {isCustom: false});
    }

    if(submissionVM.value.draftData.productCode != "Homeowners"){
        //$scope.page.standardQuotes = _.where(quoting.offeredQuotes, {branchCode: "StandardProgram"});
        $scope.page.standardQuotes = [];
    }
        $scope.page.customQuotes = _.where(quoting.offeredQuotes, {isCustom: true});
        $scope.page.offeringLabels = ctrl._setOfferingLabels($scope.page.standardQuotes);
        $scope.page.baseOffering = ctrl._setBaseOffering($scope.page.standardQuotes);
        $scope.$broadcast('CustomQuoteSelected', [$scope.page.customQuotes[0].publicID]);


    if(submissionVM.value.draftData.productCode === "PersonalAuto") {

        vehicles = submissionVM.draftData.lobs.personalAuto.value.vehicles;
        var message = '';
        for(var i in vehicles){
           message = message + ErrorHandlingService.getVehicleAgeValidated(vehicles[i], $scope.page.customQuotes);

        }
        if(message != ''){
                     ModalService.showError('quoteandbind.controllers.QuoteDetails.Attention',
                                               message).result;
        }
        drivers = submissionVM.draftData.lobs.personalAuto.value.drivers;
        for (x in $scope.page.offeringLabels) {
            if ("Best Value" == $scope.page.offeringLabels[x]) {
                $scope.tabSelected = parseInt(x) + 1;
            }
        }
        //TODO: get BI Limits from Submission VM
        if (submissionVM.draftData.lobs.personalAuto.prevCarrierInfo.priorBILimits) {
            $scope.biLimits = submissionVM.draftData.lobs.personalAuto.prevCarrierInfo.priorBILimits.value;
        } else{
            if(InMemorySession.getBiLimits()){
                $scope.biLimits = InMemorySession.getBiLimits().name;
            }
        }
        mvrClueFlag = true;
    }
};

ctrl.printQuote = ()=> {
   // $window.print();

   var url = "/pc/service/printQuote";
      $scope.pdfurl = url+"?jobNumber="+submissionVM.quoteID.value;

   var msgBox;
    msgBox = ModalService.showLoadingDialog('quoteandbind.controllers.Please wait');

   var xhr = new XMLHttpRequest();
   xhr.onreadystatechange = function() {
       if (this.status === 200) {
                if(this.readyState === 4 ){
                      // Create the Blob Obj:
                      var buffer = xhr.response;
                      const blob = new Blob([buffer], {
                          type: 'application/pdf'
                      });
                      if(window.navigator.msSaveOrOpenBlob) {
                            window.navigator.msSaveOrOpenBlob(blob, 'Quote_'+submissionVM.quoteID.value+'_AAA');
                      } else {
                           var file_path = window.URL.createObjectURL(blob);
                           var a = document.createElement('A');
                           a.href = file_path;
                           a.download = 'Quote_'+submissionVM.quoteID.value+'_AAA';
                           document.body.appendChild(a);
                           a.click();
                           document.body.removeChild(a);
                      }
                }
                msgBox.close();
       } else if(this.status != 200 && this.status != 0 && this.readyState === 4){
           msgBox.close();
           ModalService.showError('quoteandbind.controllers.ModalService.Attention','quoteandbind.controllers.Print Error') ;
       }

   };
   xhr.open('GET', $scope.pdfurl , true);
   xhr.responseType = 'arraybuffer';
   xhr.send();
       $timeout(function(){
          msgBox.close();
       }, 50000);
};

ctrl.setSelectedQuote = (quote)=> {
    if (quote.branchCode === 'CUSTOM' || quote.branchCode.indexOf('Version') === 0) {
        $scope.$broadcast('CustomQuoteSelected', [quote.publicID]);
    }

};

ctrl.getCustomQuoteHeaderCostString = ()=> {
    return `${LocaleService.getLocaleInfo().currency.symbol}0.00`;
};

jobDetails ={
    jobNumber : submissionVM.quoteID.value
}

ctrl.buy = (selectedQuote, numberOfPayments)=> {
    //stash some bind information in state data so it can be accessed later when we call the bind method
    var vinflag = 0;
    var licflag = 0;

    for(x in vehicles){
        if(vehicles[x].vin && vehicles[x].vin.length === 17 || (vehicles[x].isPrefilledVehicle && vehicles[x].encryptedVIN && InMemorySession.decryptData(vehicles[x].encryptedVIN).length === 17)){
            vinflag = vinflag+1 ;
        }
    };

    for(x in drivers){
        if(drivers[x].licenseNumber || drivers[x].eNCLicenseNumber){
            licflag = licflag+1 ;
        }
    };

     if($scope.reqoutedvehicleCoverages){
            for( index in $scope.reqoutedvehicleCoverages){
                if($scope.reqoutedvehicleCoverages[index].coverages.length == 1 && selectedQuote.lobs.personalAuto.vehicleCoverages[index].coverages.length > 1){
                    mvrClueFlag = true
                }

            }

        }

    if(vehicles.length == vinflag && drivers.length == licflag) {

        if(mvrClueFlag){
           processMVRClue(selectedQuote, numberOfPayments);
            mvrClueFlag = false;
        }else if(doReQuoteOnFail){
            getSubmission(selectedQuote, numberOfPayments);
        }else{
            StateUtils.activeDataForState(true).numberOfPayments = numberOfPayments;
            StateUtils.activeDataForState(true).chosenQuote = selectedQuote.publicID;
            submissionVM.value.bindData.chosenQuote = selectedQuote.publicID;
            flowModel.next(submissionVM);
        }
    }else{
        StateUtils.activeDataForState(true).numberOfPayments = numberOfPayments;
        StateUtils.activeDataForState(true).chosenQuote = selectedQuote.publicID;
        submissionVM.value.bindData.chosenQuote = selectedQuote.publicID;
        flowModel.next(submissionVM);
    }
};

processMVRClue = function(selectedQuote, numberOfPayments){
    var response =  MVRClueService.orderMVRClue(jobDetails);
    ModalService.showProgressDialog('quoteandbind.controllers.Please wait', response);
    var msgBox = ModalService.showLoadingDialog('quoteandbind.controllers.Please wait');

        $timeout(function(){
          msgBox.close();
          response.then(function(mvrDataResponse){
                  getSubmission(selectedQuote, numberOfPayments);
              },function(error){
                  getSubmission(selectedQuote, numberOfPayments);
          });
        }, 5000);


}


getSubmission = function(selectedQuote, numberOfPayments){
    var submissionDTO = {
        postalCode: submissionVM.draftData.accountHolder.primaryAddress.postalCode.value,
        quoteID: submissionVM.quoteID.value
    }

    var reqoutedata = LoadSaveService.saveAndReQuoteSubmission(null,submissionVM.value)
        ModalService.showProgressDialog('quoteandbind.controllers.Please wait', reqoutedata);
    reqoutedata.then(function(reQuotedResponse){
        doReQuoteOnFail = false;
        var premiumChangedFlag = 0;
        var coveragesChanged = false;
        var quotedOffers  = submissionVM.quoteData.offeredQuotes.value;
        var requotedOffers = reQuotedResponse.quoteData.offeredQuotes;
        submissionVM.value = reQuotedResponse;

        for(var x in requotedOffers){

            if(requotedOffers[x].branchCode == "CUSTOM" ) {
                if ((requotedOffers[x].monthlyPremium.amount != quotedOffers[x].monthlyPremium.amount) ||(requotedOffers[x].total.amount != quotedOffers[x].total.amount)) {
                    premiumChangedFlag = premiumChangedFlag + 1;
                }

                for(var vehicleCov in requotedOffers[x].lobs.personalAuto.vehicleCoverages){
                     if(requotedOffers[x].lobs.personalAuto.vehicleCoverages[vehicleCov].coverages.length != quotedOffers[x].lobs.personalAuto.vehicleCoverages[vehicleCov].coverages.length ){
                          coveragesChanged = true;
                     }
                }
            }
        }

        if(premiumChangedFlag > 0 || coveragesChanged){
            ModalService.showCustomInfo(
                'quoteandbind.controllers.QuoteDetails.Attention',
                'quoteandbind.controllers.QuoteDetails.quote changed').result;


                if(coveragesChanged){
                    ModalService.showCustomInfo(
                           'quoteandbind.controllers.QuoteDetails.Attention',
                           'quoteandbind.controllers.QuoteDetails.coverages have changed').result;
                }

            if(submissionVM.value.draftData.productCode === "Homeowners") {
                $scope.page.standardQuotes = _.where(requotedOffers, {isCustom: false});
            }
            if(submissionVM.value.draftData.productCode != "Homeowners"){
                //$scope.page.standardQuotes = _.where(requotedOffers, {branchCode: "StandardProgram"});
                $scope.page.standardQuotes = [];
            }
            $scope.page.customQuotes = _.where(requotedOffers, {isCustom: true});
            $scope.page.offeringLabels = ctrl._setOfferingLabels($scope.page.standardQuotes);
            $scope.page.baseOffering = ctrl._setBaseOffering($scope.page.standardQuotes);
            $scope.$broadcast('CustomQuoteSelected', [$scope.page.customQuotes[0].publicID]);
            $scope.reqoutedvehicleCoverages = $scope.page.customQuotes[0].lobs.personalAuto.vehicleCoverages;
        }else{
            $scope.page.standardQuotes = _.where(requotedOffers, {branchCode: "StandardProgram"});
            if(submissionVM.value.draftData.productCode === "PersonalAuto"){
                $scope.page.standardQuotes = [];
            }
            $scope.page.customQuotes = _.where(requotedOffers, {isCustom: true});
            if(selectedQuote.branchCode === "StandardProgram") {
                StateUtils.activeDataForState(true).numberOfPayments = numberOfPayments;
                StateUtils.activeDataForState(true).chosenQuote = $scope.page.standardQuotes[0].publicID;
                submissionVM.value.bindData.chosenQuote = $scope.page.standardQuotes[0].publicID;
            }
            else if(selectedQuote.branchCode === "CUSTOM"){
                _.where(requotedOffers, {branchCode: "CUSTOM"});
                StateUtils.activeDataForState(true).numberOfPayments = numberOfPayments;
                StateUtils.activeDataForState(true).chosenQuote = $scope.page.customQuotes[0].publicID;
                submissionVM.value.bindData.chosenQuote =  $scope.page.customQuotes[0].publicID;
            }

            flowModel.next(submissionVM);
        }

    },
    function (error) {

        var exception = {
                 error: error
                 };

         var message;

        if(error.constructor == Array && error.length > 0 && error[0].baseError && error[0].baseError.data  &&
                                     error[0].baseError.data.error && error[0].baseError.data.error.message != undefined ) {
                                     message = error[0].baseError.data.error.message;
                  }

                  if(message !== undefined && message.indexOf('coverage') > -1){
                        doReQuoteOnFail = true;
                        $scope.page.standardQuotes = [];
                        var goToStep = ErrorHandlingService.getQuoteExceptionHandler(exception,submissionVM);
                        if('error' == goToStep){
                            const messageHeader = $filter('translate')('integration.quoteandbind.directives.custom-quote.Invalid Coverage Option');
                            var errorMsg = submissionVM.draftData.lobs.value.exception
                            if(ErrorHandlingService.isDisplayError(errorMsg)){
                                ModalService.showError(messageHeader, errorMsg);
                            }else{
                             $state.go('contactUs', {quoteID: (submissionVM) ? submissionVM.quoteID.value : null,errorMsg :submissionVM.draftData.lobs.value.exception });
                            }
                        }

                  }else{
                    ErrorHandlingService.getBindExceptionHandler(exception,submissionVM);
                    $state.go('contactUs', {quoteID: (submissionVM) ? submissionVM.quoteID.value : null,errorMsg :submissionVM.draftData.lobs.value.exception });
                  }

        /*const errorPromise = ModalService.showError(
            'quoteandbind.common.config.FlowConfig.Unable to generate a quote',
            'quoteandbind.common.config.FlowConfig.An error occurred while attempting to calculate a quote.'
        ).result;
        errorPromise.then(function(resp) {
            $state.go('contactUs', {quoteID: (submissionVM) ? submissionVM.quoteID.value : null});
        });*/
    });
}


ctrl.nextSteps = (selectedQuote, numberOfPayments)=> {
    //stash some bind information in state data so it can be accessed later when we call the bind method
    StateUtils.activeDataForState(true).numberOfPayments = numberOfPayments;
    StateUtils.activeDataForState(true).chosenQuote = selectedQuote.publicID;
   // StateUtils.activeDataForState(true).flowModel =  flowModel;
    // Redirect to next steps state
    //$state.go("nextSteps");
    flowModel.next(submissionVM);
};


ctrl._setOfferingLabels = (standardOfferings)=> {
    return _.map(standardOfferings, (offering)=> {
            return $filter('translate')(`quoteandbind.controllers.QuoteDetails.${offering.branchCode}`);
});
};

ctrl._setBaseOffering = (standardOfferings)=> {
    if (angular.isArray(standardOfferings) && standardOfferings.length === 1) {
        return standardOfferings[0];
    } else if (angular.isArray(standardOfferings) && standardOfferings.length > 1) {
        return standardOfferings[1];
    }
};

return ctrl.create($scope);
};
fn.$inject = ['LocaleService', '$filter', '$scope', '$anchorScroll', 'StateUtils', 'qnb.LoadSaveService', 'MVRClueService','$window', 'submissionViewModel', '$state', 'ModalService', 'InMemorySession', 'qnb.ErrorHandlingService', '$timeout'];

return fn;
});



/** WEBPACK FOOTER **
 ** ./common/js/src/edge/quoteandbind/common/controllers/QuoteDetailsCtrl.js
 **/